<script>
import selectDeckForCopy from '~/queries/selectDeckForCopy.gql'
import insertDeckCopy from '~/queries/insertDeckCopy.gql'
import { mergeDeckAndSettingsData } from '~/common/deck-settings'

export default {
  data () {
    return {
      highlightDeck: 0
    }
  },
  methods: {
    async duplicateDeck (deckId, deckSettingsData = {}, options = { keepName: false }) {
      this.log('duplicating deck from decks.vue')

      const { data: { slideDecks } } = await this.$apollo.query({
        query: selectDeckForCopy,
        variables: {
          id: deckId
        }
      })

      const deck = mergeDeckAndSettingsData(slideDecks[0], deckSettingsData)

      if (!deck || !deck.slides || deck.slides.length < 1) {
        this.throwError({ message: 'Cannot duplicate: Deck not found or not public' }, 'toast')
        return
      }

      if (deck.teamData?.allowCopy === false) {
        this.$buefy.toast.open({ type: 'is-warning', message: 'Owner does not allow copying this deck' })
        return
      }

      let slides = [ ...deck.slides ]
      const isProUser = this.$store.getters.isProUser

      slides = slides.map((slide) => {
        // remove hidden logos when deck is copied by non-pro users
        if (!isProUser) { slide.options.hideLogoThisSlide = slide.template === 'joinSlide' }

        return {
          options: slide.options,
          content: slide.content,
          prompts: slide.prompts,
          template: slide.template,
          order: slide.order,
          userId: this.$auth.user.id,
          answers: slide.answers,
          steps: slide.steps,
          speakerNotes: slide.speakerNotes
        }
      })

      // clear custom logos & branding for non-pro users
      if (!isProUser) {
        deck.metaData.showModeratorBrand = true
        deck.metaData.showPlayerBrand = true
      }

      // if current user owns deck, copy settings
      const teamData = {}
      if (deck.userId === this.user.id && deck.teamData) {
        teamData.lockDeckSettings = deck.teamData.lockDeckSettings || false
        teamData.allowCopy = deck.teamData.allowCopy || true
        teamData.allowEdit = deck.teamData.allowEdit || true
      }

      // if current user owns deck or deckSettingsData were provided, copy eventSettings
      let eventSettings = {}
      if ((deckSettingsData && deckSettingsData.eventSettings) || (deck.userId === this.user.id && deck.eventSettings)) {
        eventSettings = deck.eventSettings
        if (!isProUser) { delete eventSettings.collectPlayerEmails }
        if (eventSettings.shortcode) { delete eventSettings.shortcode } // don't bring join codes with copies
      }

      this.log('copying deck with settings: ', teamData, eventSettings)

      // eslint-disable-next-line camelcase
      const { data: { insert_slideDecks } } = await this.$apollo.mutate({
        mutation: insertDeckCopy,
        variables: {
          name: options.keepName ? deck.name : 'Copy of ' + deck.name,
          themeData: deck.themeData,
          metaData: deck.metaData,
          copyFromDeckId: deckId,
          userId: this.$auth.user.id,
          slides: { data: slides },
          isPublic: deck.isPublic,
          teamData: teamData || {},
          eventSettings: eventSettings || {}
        }
      })

      // eslint-disable-next-line camelcase
      const newDeck = insert_slideDecks
      if (!newDeck || !newDeck.returning || !newDeck.returning[0]) {
        this.throwError({ message: 'Error creating new slide deck' }, 'toast')
      }

      this.highlightDeck = newDeck.returning[0].id
    }
  }
}
</script>
